import { render, staticRenderFns } from "./quesList.vue?vue&type=template&id=2b759f9a&scoped=true"
import script from "./quesList.vue?vue&type=script&lang=js"
export * from "./quesList.vue?vue&type=script&lang=js"
import style0 from "./quesList.vue?vue&type=style&index=0&id=2b759f9a&prod&scoped=true&lang=css"
import style1 from "./quesList.vue?vue&type=style&index=1&id=2b759f9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b759f9a",
  null
  
)

export default component.exports